import { useEffect } from 'react';

import { IUseFabric } from './types';

export const useEraser = (props: IUseFabric) => {
  const { ref, context } = props;
  const { annotationEnabled, mode } = context;

  useEffect(() => {
    const canvas = ref.current;
    const handleEraser = () => {
      const list = canvas.getActiveObjects();
      if (list?.length > 0) {
        canvas
          .discardActiveObject()
          .remove(...list)
          .renderAll();
      }
    }

    if (annotationEnabled && mode === 'eraser') {
      canvas.on('mouse:up', handleEraser);
      return () => {
        canvas.off('mouse:up', handleEraser);
      }
    }
  }, [annotationEnabled, mode, ref]);
}
